// extracted by mini-css-extract-plugin
export default {"searchSuggestionSection":"SearchSuggestionSection_searchSuggestionSection__7JOxA","sectionTitle":"SearchSuggestionSection_sectionTitle__MiXEw"};